import React, { useState,useEffect } from "react"; 
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer'; 
import { form1 } from "../Service/Api";
import { getHeader } from "../config";
const ContactUs = () => {
     useEffect(() => {
        document.title = 'Contact Us -  St Peters convent School Faridabad Haryana';  
    }, []); 
    const [formData, setFormData] = useState({
        name: "", 
        phone: "",
        email: "",
        subject: "",
        message: "",
    });
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setErrors({ ...errors, [e.target.name]: "" }); // Clear the error for the field being changed
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required.";
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Email is not valid.";
        }
        if (!formData.phone) newErrors.phone = "Phone Number is required.";
        if (!formData.subject) newErrors.subject = "Subject is required.";
        if (!formData.message) newErrors.message = "Message is required.";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const type = 'abc'; 
        console.log('Submitting form with type:', type); // Debugging line
        try {
            const { header } = getHeader();
            const response = await form1(formData, header, type); 
            console.log('Form submitted successfully', response);
            document.querySelector(".primary-alert").innerHTML = "<p>Your Form Submitted Successfully.</p>";
            setFormData({
                name: "", 
                phone: "",
                email: "",
                subject: "",
                message: "",
            });
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>  
     <li>Contact Us </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Contact Us  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <div class="enquiryform">
           <div class="enquiryformimg">
                <div class="locationbox">
                    <div class="locationdiv">
                         <div class="locationicon"><i class="bi bi-geo-alt"></i></div>
                           <div class="locationdetails">
                             <h5>address</h5>
                             <p><a href="https://maps.app.goo.gl/g42tdKdPDzoQrYSs8" target="_blank">  ​St Peter's Convent School, Sec-88, Greater Faridabad, Haryana-121002</a></p>
                        </div>
                     </div>
                     <div class="locationdiv">
                         <div class="locationicon"><i class="bi bi-telephone"></i></div>
                         <div class="locationdetails">
                         <h5>Phone</h5>
                         <p><a href="tel:+91 7065054701"> +91 7065054701, </a> <a href="tel:+91 9560356167"> +91 9560356167 </a> </p>
                         </div>
                    </div>
                    <div class="locationdiv">
                       <div class="locationicon"><i class="bi bi-envelope"></i></div>
                       <div class="locationdetails">
                       <h5>Email</h5>
                       <p><a href="mailto:spetercsfbd@gmail.com"> spetercsfbd@gmail.com</a></p>
                       </div>
                       </div>
                       </div>
                </div>
                <div className="formboxright"> 
                    <form onSubmit={handleSubmit}>
                        <div className="formdiv">
                            <div className="form-group">
                                <label>Name<span>*</span></label>
                                <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange}/>
                                {errors.name && <div className="error">{errors.name}</div>}
                            </div>
                            <div className="form-group">
                                <label>Email<span>*</span></label>
                                <input type="text" name="email" className="form-control" value={formData.email} onChange={handleChange}/>
                                {errors.email && <div className="error">{errors.email}</div>}
                            </div>
                            <div className="form-group">
                                <label>Phone No.<span>*</span></label>
                                <input type="text" name="phone" className="form-control" value={formData.phone} onChange={handleChange}/>
                                {errors.phone && <div className="error">{errors.phone}</div>}
                            </div>
                            <div className="form-group">
                                <label>Subject<span>*</span></label>
                                <input type="text" name="subject" className="form-control" value={formData.subject} onChange={handleChange}/>
                                {errors.subject && <div className="error">{errors.subject}</div>}
                            </div>
                            <div className="form-group textarea">
                                <label>Your Message<span>*</span></label>
                                <textarea name="message" className="form-control" value={formData.message} onChange={handleChange}></textarea>
                                {errors.message && <div className="error">{errors.message}</div>}
                            </div>
                        </div>
                        <input type="submit" value="Submit"/>
                        <div className="row"> 
                            <div className="col-lg-12 col-md-12">
                                <div className='primary-alert'></div>
                            </div>
                        </div>
                    </form>
                </div>
          </div>   
          
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.253694104019!2d77.3573188!3d28.4116009!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cdd21a4b1c9c9%3A0x434559132d3df62a!2sSt.%20Peter%E2%80%99s%20Convent%20School%20sec%2088%2C%20Greater%20Faridabad.!5e0!3m2!1sen!2sin!4v1745465748204!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default ContactUs
